module.exports = ".container\n{\n  padding: 10px;\n}"